export const MenuPlacements = {
  AUTO: 'auto',
  BOTTOM: 'bottom',
  TOP: 'top',
};
